import { Injectable } from '@angular/core';

import { ClientLogMessage } from '../../models';
import { ApiService } from '../api.service';
import { LogApi } from '../../../../../generated/internalApi';
import { SETTINGS } from '../../../clpbp-app.settings';

const ClientLogKey = {
  DEV: '9d0c1844-ee57-4d96-932b-8cb7063a5157',
  QA: '1423a18a-5432-4d77-8dd6-e3ecea6b122a',
  STG: 'a9eb6fb8-b726-4be0-b003-9002c93007d2',
  PRD: '88bd7549-d435-46f0-91ea-c0b155ddff54',
  LV8DEMO: 'daa16450-b96c-4da4-9bb9-60afc84e096b',
  DEMO: '58816c5c-f4bf-44d6-a99c-111566f3eb21',
  PERF: '8c790590-672a-4581-a3d7-56b970f6ee2b'
};

@Injectable()
export class ErrorHandlerApiService extends ApiService {
  constructor(private logApi: LogApi) {
    super(null);

    this.setHeaders();
  }

  public logToApi(error: Error, severity: string = 'ERROR'): void {
    if (!error) {
      return;
    }

    const logLevel = ClientLogMessage.LogLevelEnum[severity] || ClientLogMessage.LogLevelEnum['ERROR'];

    const message: ClientLogMessage = {
      'eventTime': new Date(),
      'logLevel': logLevel,
      'class': window.location.href,
      'message': '[ULA-Angular] ' + error.toString(),
      'exception': error.stack,
      'metadata': {
        'url': window.location.href,
        'stacktrace': error.stack
      }
    };

    this.logApi.logLog(message, this.getKey(), this.getKey()).subscribe();
  }

  private setHeaders(): void {
    this.logApi.defaultHeaders.set('Client-Log-Key', this.getKey());
  }

  private getKey(): string {
    // @TODO this should probably lookup SETTINGS.ENV but that doesn't exist yet…
    // but then we wouldn't have these very specific URLs in two spots...
    // if they ever change in SETTINGS, they'll need to change here too.
    switch (SETTINGS.API.URL) {
      case 'https://clpbp-public-dv1.loandepotdev.works':
      case 'http://localhost:2586':
        return ClientLogKey.DEV;
      case 'https://clpbp-public-qa1.loandepotdev.works':
        return ClientLogKey.QA;
      case 'https://clpbp-public-sg1.loandepotdev.works':
        return ClientLogKey.STG;
      case 'https://clpbpapi.myloandepot.com':
        return ClientLogKey.PRD;
      case 'https://clpbp-public-perf.loandepotdev.works':
        return ClientLogKey.PERF;
      case 'https://clpbp-public-dem.loandepotdev.works':
        return ClientLogKey.DEMO;
      default:
        return null;
    }
  }
}
